import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


export default class Filter {
  constructor(dom) {
    window.addEventListener("resize", () => this.resize());
    this.dom = dom
    console.log(this.dom);
    this.loading = false

    this.queryValues = {
      'date_start': '',
      'date_end': '',
      'type': '',
      // 'location' : '',
      'categories': [],
      'locations': [],
      'hide_past_programmes': 0,
      'archive': '',
      'pages': 1,
    }



    mobiscroll.datepicker(this.dom.querySelector('#date-start-end'), {
      touchUi: false,
      select: 'range',
      startInput: this.dom.querySelector('#date-start'),
      endInput: this.dom.querySelector('#date-end'),
    });

    [...this.dom.querySelectorAll('form input[type="checkbox"]')].forEach((item, i) => {
      item.addEventListener('change', (e) => {
        // console.log(e.target);
      })
    });


    this.dom.querySelector('form.filter-items').addEventListener('submit', (e) => {
      e.preventDefault()

      if (this.loading) {
        return
      }

      this.queryValues = {
        'date_start': '',
        'date_end': '',
        'type': '',
        // 'location': '',
        'categories': [],
        'locations': [],
        'hide_past_programmes': 0,
        'archive': '',
        'pages': 1,
      }

      var formData = new FormData(e.target);
      // output as an object
      console.log(Object.fromEntries(formData));

      // ...or iterate through the name-value pairs
      for (var pair of formData.entries()) {
        console.log(pair[0] + ": " + pair[1]);
        if (!pair[1]) {
          continue
        }
        let key = ''
        let val = ''
        switch (pair[0]) {
          // case 'date_start':
          // case 'date_end':
          //   key = pair[0]
          //   val = this.getDateFormat(pair[1])
          //   break;
          case 'location[]':
            key = 'locations'
            this.queryValues['locations'].push(pair[1])
            val = this.queryValues['locations']
            break;
          case 'category[]':
            key = 'categories'
            this.queryValues['categories'].push(pair[1])
            val = this.queryValues['categories']
            break;
          case 'hide_past_programmes':
            key = pair[0]
            val = 1
            break;
          default:
            key = pair[0]
            val = pair[1]
            break;
        }
        this.queryValues[key] = val
        this.historyPushState(key, val)
        // console.log(this.queryValues);
      }

      this.queryValues['pages'] = 1
      this.historyPushState('pages', 1)

      this.fetchData()
    })

    this.initPagination()
  }

  historyPushState(type, val) {
    const url = new URL(window.location);
    url.searchParams.set(type, val);
    window.history.pushState({}, "", url);
  }

  initPagination() {
    const pages = document.querySelectorAll('.www-pagination .page-link')

    if (pages) {
      pages.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          e.preventDefault()

          if (this.loading) {
            return
          }

          this.queryValues['pages'] = parseInt(item.dataset.page)
          this.historyPushState('pages', parseInt(item.dataset.page))
          this.fetchData()
        })
      });


    }
  }

  getDateFormat(date) {
    let objectDate = new Date(date);

    let day = objectDate.getDate();

    let month = objectDate.getMonth();
    month = month + 1
    let year = objectDate.getFullYear();

    if (day < 10) {
      day = '0' + day;
    }

    if (month < 10) {
      month = `0${month}`;
    }

    return `${year}-${month}-${day}`
  }

  fetchData() {

    this.loading = true

    fetch("?api=getProgrammeItems", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.queryValues),
    })
    .then((response) => response.json())
    .then((response) => {
      this.loading = false

      let old_items = document.querySelector("[js-programme-items]");
      let old_pagination = document.querySelector("[js-pagination]");

      let new_items = document.createElement("div");
      new_items.innerHTML = response.items.trim();
      let new_pagination = document.createElement("div");
      new_pagination.innerHTML = response.pagination.trim();

      old_items.parentNode.replaceChild(new_items.firstChild, old_items);
      old_pagination.parentNode.replaceChild(new_pagination.firstChild, old_pagination);

      this.initPagination()
    })
  }

  init() {

  }

  resize() {
  }

}
